

import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { styled, useTheme } from '@mui/material/styles';
import KeyboardDoubleArrowDown from '@mui/icons-material/KeyboardDoubleArrowDown'
import KeyboardDoubleArrowUp from '@mui/icons-material/KeyboardDoubleArrowUp'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { Grid, Typography } from '@mui/material';
import config from '../../config.json'


interface DesktopBottomDrawerProps {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    children: React.ReactNode
}

/**
  * Wrapper-Component that puts children into Persistent Desktop Drawer.
  */
export default function DesktopBottomDrawer({ open, setOpen, children }: DesktopBottomDrawerProps) {

    const theme = useTheme();
    const widthBleeding = 150;
    const marginLeft = (-widthBleeding / 2) //(drawerWidth/2)- (width/2)  
    // const maxWidth = 950;
    const drawerBleeding = 56;
    const StyledBox = styled(Box)(({ theme }) => ({
        backgroundColor: "white"
    }));

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    function OpenCloseButton() {
        return (
            <StyledBox
                sx={{
                    position: 'absolute',
                    top: -drawerBleeding + 7,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    visibility: 'visible',
                    width: `${widthBleeding}px`,
                    ml: `${marginLeft}px`,
                    left: "50%",
                    backgroundColor: theme.palette.customBackground.main,
                }}
            >
                <Box>
                    <Grid container justifyContent="center">
                        <IconButton onClick={toggleDrawer(!open)}>
                            {open ? <KeyboardDoubleArrowDown /> : <KeyboardDoubleArrowUp />}
                        </IconButton>
                    </Grid>
                </Box>
                <Container sx={{ p: 1 }}></Container>
            </StyledBox>
        )


    }

    // Needs to be adjusted so it can be called in ContentBottomDrawer
    return (

        <Box
            sx={{
                ".MuiDrawer-root > .MuiPaper-root": {
                    height: `calc(42% - ${drawerBleeding}px+20px)`,
                    backgroundColor: 'customBackground.main',
                    marginLeft: `${config.sizing.drawerWidthDesktop}px`,
                    zIndex: 10000,
                    overflow: "visible"

                }
            }}
        >
            <SwipeableDrawer
                sx={{
                    '& .MuiDrawer-paper': {
                        height: "42%",
                        overflow:"visible"

                    }
                }}
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={56}
                disableSwipeToOpen={false}
                ModalProps={{
                    keepMounted: true,
                }}
                variant="persistent" //remove to activate swipe behaviour,
            >
                <Box
                    sx={{
                        px: 2,
                        pb: 2,
                        // height: '80%',
                    }}
                >
                    <OpenCloseButton/>


                    {children}
                </Box>
            </SwipeableDrawer>
        </Box>
    )
}





